// Generated by Melange

import * as Buhta_cabinet__ClassifierModel from "../../models/ClassifierModel.js";
import * as Buhta_cabinet__KogdTableView from "./KogdTableView.js";
import * as Curry from "melange.js/curry.js";
import * as StaticAsset from "../../../../../packages/util/lib/StaticAsset.js";
import * as Stdlib__List from "melange/list.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function make(ogds) {
  return function (onKogdSelect) {
    return function (setIsDropdownShown) {
      const match = React.useState(function () {
            return "";
          });
      const setWord = match[1];
      const word = match[0];
      const match$1 = React.useState(function () {
            return /* [] */0;
          });
      const setFilteredOgds = match$1[1];
      React.useEffect((function () {
              const result = word === "" ? ogds : Stdlib__List.map((function (param) {
                        const filteredArr = Stdlib__List.filter((function (a) {
                                if (Buhta_cabinet__ClassifierModel.wordFound(word, a.code) || Buhta_cabinet__ClassifierModel.wordFound(word, a.name)) {
                                  return true;
                                } else {
                                  return Buhta_cabinet__ClassifierModel.wordFound(word, a.keywords);
                                }
                              }), param[1]);
                        return [
                                param[0],
                                filteredArr
                              ];
                      }), ogds);
              Curry._1(setFilteredOgds, (function (param) {
                      return result;
                    }));
            }), [
            word,
            ogds
          ]);
      return JsxRuntime.jsxs(React.Fragment, {
                  children: [
                    JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx("img", {
                                  className: "w-5 h-5",
                                  src: StaticAsset.src("/static/icons/search-24-gray.svg")
                                }),
                            JsxRuntime.jsx("input", {
                                  className: "paragraph text-black-landing w-full",
                                  placeholder: "Поиск...",
                                  type: "text",
                                  value: word,
                                  onChange: (function (ev) {
                                      const value = ev.target.value;
                                      Curry._1(setWord, (function (param) {
                                              return value;
                                            }));
                                    })
                                })
                          ],
                          className: "px-4 py-2 flex gap-1 items-center border-b border-gray-main toast-card"
                        }),
                    JsxRuntime.jsx(Buhta_cabinet__KogdTableView.make, {
                          ogds: match$1[0],
                          onKogdSelect: onKogdSelect,
                          setIsDropdownShown: setIsDropdownShown
                        })
                  ]
                });
    };
  };
}

function ClassifiersKogdList(Props) {
  return Curry._1(make(Props.ogds)(Props.onKogdSelect), Props.setIsDropdownShown);
}

const make$1 = ClassifiersKogdList;

export {
  make$1 as make,
}
/* Buhta_cabinet__KogdTableView Not a pure module */
